import { Quiz409Translations } from './quizExpired.translation.pl';

export const quizClosedTranslations: Quiz409Translations = {
  title: '',
  subMessage:
    'Dziękujemy za zainteresowanie, ale zakończyliśmy już zbieranie aplikacji. Zapraszamy za rok!',
  buttons: {
    back: 'Start',
  },
};
